import React from 'react'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Tooltip from 'components_new/atoms/Tooltip'

import EditableTitle from 'components_new/molecules/EditableTitle'

interface GenericWidgetHeaderProps {
  disableSubtitle?: boolean
  disableTitle?: boolean
  editMode: boolean
  onChangeSubtitle: (value: string | null) => void
  onChangeTitle: (value: string | null) => void
  scaleFactor: number
  subtitle?: string | null
  title?: string | null
  tooltip?: string | null
}

const GenericWidgetHeader = (props: GenericWidgetHeaderProps) => {
  const {
    disableSubtitle,
    disableTitle,
    editMode,
    scaleFactor,
    onChangeSubtitle,
    onChangeTitle,
    subtitle,
    title,
    tooltip
  } = props

  if (disableSubtitle && disableTitle) return null

  return (
    <Box
      sx={{
        position: 'relative',
        height: 'auto',
        pb: 1 * scaleFactor
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
        {!disableTitle ? (
          <Box
            sx={{
              alignItems: 'center',
              color: 'text.primary',
              display: 'flex',
              fontSize: 20 * scaleFactor,
              flex: 1,
              minWidth: 0,
              width: '100%'
            }}
          >
            {tooltip ? (
              <Tooltip title={tooltip}>
                <Icon fontSize="inherit" name={'Info'} sx={{ mr: 0.5 }} />
              </Tooltip>
            ) : null}
            <EditableTitle
              color="text.primary"
              disabled={!editMode}
              fontSize={20 * scaleFactor}
              onSubmit={onChangeTitle}
              sx={{ flex: 1 }}
              value={title ?? null}
              variant="subtitle1"
            />
          </Box>
        ) : null}

        {!disableSubtitle ? (
          <Box sx={{ mt: 0.5 * scaleFactor }}>
            <EditableTitle
              color="text.secondary"
              disabled={!editMode}
              fontSize={16 * scaleFactor}
              onSubmit={onChangeSubtitle}
              value={subtitle ?? null}
              variant="subtitle2"
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  )
}

export default GenericWidgetHeader
